import {Link} from "react-router-dom";

import './Gallery.css';
import "../Common.css"

import useScript from '../useScript';

function Gallery()
{
    useScript('../js/gallery.js');
    //useScript('../js/mosaic.js');

    return (
        <div id="galleryMosaics"></div>
    )
}

export default Gallery;